import { TabOrder } from 'hooks/useOrderTabs';
import { infoUpdateType } from 'types/notifications';

export type FilterUser = {
  username?: string;
  login_email?: string;
  emails?: { address: string }[];
} | null | undefined;

export type EvaluateResult =
  | { notify: true; reason: 'ok'; tab: TabOrder }
  | { notify: false; reason: 'no-user' | 'system-actor' | 'mutation' | 'self' | 'no-order' | 'tab-closed' };

type EvaluateInput = {
  event: infoUpdateType;
  currentUser: FilterUser;
  openTabs: TabOrder[];
};

const SYSTEM_ACTORS = ['Worker', 'Hook'];

export const normalizeEmail = (value: unknown): string => (
  typeof value === 'string' ? value.trim().toLowerCase() : ''
);

export const getUserEmails = (currentUser: FilterUser): string[] => {
  if (!currentUser) return [];
  const addresses = Array.isArray(currentUser.emails)
    ? currentUser.emails.map((email) => email?.address)
    : [];
  const candidates = [...addresses, currentUser.username, currentUser.login_email]
    .map(normalizeEmail)
    .filter((email) => email !== '');
  return Array.from(new Set(candidates));
};

export const evaluateEvent = ({ event, currentUser, openTabs }: EvaluateInput): EvaluateResult => {
  if (!currentUser) return { notify: false, reason: 'no-user' };
  if (SYSTEM_ACTORS.includes(event?.name)) return { notify: false, reason: 'system-actor' };
  if (event?.kind === 'mutation') return { notify: false, reason: 'mutation' };

  const actorEmail = normalizeEmail(event?.email);
  if (actorEmail !== '' && getUserEmails(currentUser).includes(actorEmail)) {
    return { notify: false, reason: 'self' };
  }

  const orderId = event?.update?._id;
  if (!orderId) return { notify: false, reason: 'no-order' };

  const tab = (Array.isArray(openTabs) ? openTabs : []).find((openTab) => openTab.id === orderId);
  if (!tab) return { notify: false, reason: 'tab-closed' };

  return { notify: true, reason: 'ok', tab };
};

export const createDedupe = ({ windowMs = 5000 }: { windowMs?: number } = {}) => {
  const lastDelivered = new Map<string, number>();

  return {
    shouldDeliver(key: string, now: number): boolean {
      lastDelivered.forEach((timestamp, storedKey) => {
        if (now - timestamp >= windowMs) lastDelivered.delete(storedKey);
      });
      if (lastDelivered.has(key)) return false;
      lastDelivered.set(key, now);
      return true;
    },
    size(): number {
      return lastDelivered.size;
    },
  };
};
